export const normalizeCourseCode = (value) =>
  (value || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');

export const getCourseCodeFamilyMatches = (courses = [], searchValue = '') => {
  const normalizedSearchValue = normalizeCourseCode(searchValue);
  if(!normalizedSearchValue) return [];

  return courses.filter((course) => {
    const normalizedCourseCode = normalizeCourseCode(course?.course_code);
    if(normalizedCourseCode === normalizedSearchValue) return true;

    const courseCodeSuffix = normalizedCourseCode.slice(normalizedSearchValue.length);
    return normalizedCourseCode.startsWith(normalizedSearchValue) && /^[a-z]+$/.test(courseCodeSuffix);
  });
};
